import store from "@/app/store/index";

// 页面中有思维导图时打开提示
const checkMindmap = function () {
    const isMMShape = store.state.shape.isMMShape;
    const isActived = store.state.shape.isActived;
    const shapeList = window["_view"]._activePage._children;
    const isIgnore = localStorage.getItem("ignoreMindTips") === "true";
    let flag = false;
    if (isIgnore) return;
    let isAllMMItem = true;
    if (!shapeList.length) {
        isAllMMItem = false;
    }
    for (const item of shapeList) {
        if (!(item instanceof EDMMShape || item instanceof EDMMConnector)) {
            // 存在不属于思维导图连接线或者思维导图形状
            isAllMMItem = false;
            console.log("存在不属于思维导图连接线或者思维导图形状");
            break;
        }
    }
    if (isAllMMItem) flag = true; // 当画布上只剩思维导图连接线和思维导图框形状时
    if (isMMShape && isActived) flag = true; // 当选中的图形为思维导图时
    if (flag) {
        store.commit("setStatus", {
            type: "showMindTipsDialog",
            data: true,
        });
    }
};

export default checkMindmap;
